module.exports = __webpack_public_path__ + "img/banner.bb858a39.png";